import { createFileRoute } from '@tanstack/react-router';
import { LearnPage } from '@/features/Course/learn/LearnPage';

export const Route = createFileRoute('/_student/courses/$batchId/learn')({
  component: LearnRoute,
});

function LearnRoute() {
  const { batchId } = Route.useParams();
  return <LearnPage batchId={batchId} />;
}
